// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function YoutubeLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m20.555 15.168-6-4A1 1 0 0 0 13 12v8a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.665ZM15 18.13v-4.256L18.198 16 15 18.131ZM29.291 8.69a3 3 0 0 0-1.811-2.05C23.195 4.985 16.375 5 16 5S8.805 4.985 4.52 6.64a3 3 0 0 0-1.811 2.05C2.385 9.938 2 12.217 2 16c0 3.782.385 6.063.709 7.31a3 3 0 0 0 1.811 2.051C8.625 26.945 15.05 27 15.918 27h.165c.867 0 7.296-.055 11.397-1.639a3 3 0 0 0 1.811-2.051c.324-1.25.709-3.527.709-7.31 0-3.783-.385-6.063-.709-7.31Zm-1.936 14.125a1 1 0 0 1-.596.686c-3.957 1.528-10.685 1.5-10.75 1.5H16c-.068 0-6.791.025-10.75-1.5a1 1 0 0 1-.596-.686C4.35 21.674 4 19.571 4 16s.35-5.674.645-6.809a1 1 0 0 1 .596-.691C9.056 7.026 15.45 7 15.973 7h.033c.068 0 6.798-.022 10.75 1.5a1 1 0 0 1 .596.686C27.65 10.326 28 12.43 28 16s-.35 5.674-.645 6.809v.006Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
